import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { useKeywordsCampaignsContext } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsContext";
import { getRTDurationObjectForCampaign } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsContextUtils";
import type { RtCampaignScrapeContext } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import type { RTRawParams } from "app/pages/digital-marketing/keywords-campaigns/reports/types";
import type { DatesRange } from "app/pages/digital-marketing/keywords-campaigns/shared/types";

/**
 * Resolves the route `duration` param to `{ from, to }` for report API calls.
 * Pass `campaignOverride` when the caller supplies campaign config (e.g. dashboard widgets).
 */
export const useRTApiDuration = (campaignOverride?: RtCampaignScrapeContext | null): DatesRange | undefined => {
    const rtContext = useKeywordsCampaignsContext();
    const { params } = useCurrentStateAndParams<RTRawParams>();
    const campaign = campaignOverride ?? rtContext?.currentCampaignConfiguration;

    return useMemo(
        () => (params.duration && campaign ? getRTDurationObjectForCampaign(params.duration, campaign) : undefined),
        [params.duration, campaign],
    );
};
